<script>
    import { onMount, beforeUpdate, afterUpdate, onDestroy, tick } from "svelte"
    import {slide} from "svelte/transition"

    console.log("Initializing AgeOutput")

    export let name
    export let age

    $: console.log("name changed to", name)
    $: console.log("age changed to", age)

    onMount(async () => await console.log("AgeOutput mounted"))
    beforeUpdate(() => tick().then(() => console.log("AgeOutput tick")))
    afterUpdate(() => console.log("AgeOutput after update"))
    onDestroy(() => console.log("AgeOutput destroyed"))

    console.log("AgeOutput initialized")
</script>

<style>
    div {
        margin-top: 2rem;
    }
</style>

{#if name && name.trim().length !== 0 && age}
    <div transition:slide>
        {name}, your age is:
        <ul>
            {#each Object.keys(age) as unit}
                <li>{age[unit]} {unit}</li>
            {/each}
        </ul>
    </div>
{/if}
